<script>
	import lookups from "../stores/lookupStore";
	import Person from "../models/Person";

	import TextInput from "./TextInput.svelte";
	import Checkbox from "./Checkbox.svelte";
	import Select from "./Select.svelte";
	import FormRow from "./FormRow.svelte";
	import FormColumn from "./FormColumn.svelte";
	import AddButton from "./buttons/AddButton.svelte";

	export let claimantDetails;
	export let claimants;
	export let contactFirstName = null;
	export let contactSurname = null;
	export let disabled = null;

	let contact = new Person();
	contact.firstName = contactFirstName;
	contact.surname = contactSurname;
	contact.isContact = true;

	if (!claimants || !claimants.length) {
		claimants = [new Person()];
	}

	const addExecutor = () => {
		claimants = [...claimants, new Person()];
	};

	const deleteExecutor = (index) => {
		if (claimants.length <= 1) return;
		if (claimants[index].isContact) {
			claimantDetails.executor = false;
		}
		claimants.splice(index, 1);
		claimants = [...claimants];
	};

	const handleExecutorChange = (e) => {
		if (e.target.checked) {
			claimants.unshift(contact);

			let indexEmptyContact = claimants.findIndex((e) => !e.firstName && !e.surname);
			if (indexEmptyContact >= 0) {
				deleteExecutor(indexEmptyContact);
			}
		} else {
			let indexContact = claimants.findIndex((e) => e.isContact);
			if (indexContact >= 0) {
				claimants.splice(indexContact, 1);
				if (claimants.length == 0) {
					claimants = [new Person()];
				}
			}
		}

		claimants = [...claimants];
	};

	const handleContactNameChange = (contactFirstName, contactSurname) => {
		contact.firstName = contactFirstName;
		contact.surname = contactSurname;

		if (claimantDetails.executor) {
			var indexContact = claimants.findIndex((e) => e.isContact);
			if (indexContact >= 0) {
				claimants[indexContact].firstName = contactFirstName;
				claimants[indexContact].surname = contactSurname;
			}
		}

		claimants = [...claimants];
	};

	$: {
		handleContactNameChange(contactFirstName, contactSurname);
	}
</script>

<FormRow>
	<FormColumn>
		<h2>Claimant Details</h2>
	</FormColumn>
</FormRow>

<FormRow>
	<FormColumn>
		<TextInput
			label="Name of Estate"
			required
			{disabled}
			bind:value={claimantDetails.claimantName}
			id="s_firstName"
		/>
	</FormColumn>
</FormRow>

<FormRow>
	<FormColumn>
		<Checkbox
			{disabled}
			on:change={handleExecutorChange}
			bind:checked={claimantDetails.executor}
			label="I am an executor"
			id="exec"
		></Checkbox>
	</FormColumn>
</FormRow>

<FormRow class="mt-0">
	<FormColumn cols="11">
		<FormRow>
			<FormColumn cols="6" class="d-none d-md-block">
				<!-- svelte-ignore a11y-label-has-associated-control -->
				<label>
					Executor first name
					<span class="required">*</span>
				</label>
			</FormColumn>
			<FormColumn cols="6" class="d-none d-md-block">
				<!-- svelte-ignore a11y-label-has-associated-control -->
				<label>
					Executor last name
					<span class="required">*</span>
				</label>
			</FormColumn>
		</FormRow>
	</FormColumn>
</FormRow>

<div class="executors">
	{#each claimants as claimant, i (claimant)}
		<div class="executor">
			<FormRow class="mt-2">
				<FormColumn cols="11">
					<FormRow class="mt-0">
						<FormColumn cols="6">
							<TextInput
								required
								disabled={disabled || claimant.isContact}
								placeholder="Executor first name"
								bind:value={claimant.firstName}
								id="firstName{i}"
							/>
						</FormColumn>
						<FormColumn cols="6">
							<TextInput
								required
								disabled={disabled || claimant.isContact}
								placeholder="Executor last  name"
								bind:value={claimant.surname}
								id="surname{i}"
							/>
						</FormColumn>
					</FormRow>
				</FormColumn>
				<FormColumn cols="1" class="last mt-0">
					{#if claimants.length > 1}
						<div class="confirmation-hide">
							<button
								on:click|preventDefault={() => deleteExecutor(i)}
								class="delete"
								title="Delete transaction"
								aria-label="Delete transaction"
							>
								<i class="fas fa-trash"></i>
							</button>
						</div>
					{/if}
				</FormColumn>
			</FormRow>
		</div>
	{/each}

	<div class="confirmation-hide" style="margin-top: 20px;">
		<AddButton on:add={addExecutor}>Add another executor</AddButton>
	</div>
</div>

<FormRow>
	<FormColumn>
		<Checkbox
			required
			{disabled}
			bind:checked={claimantDetails.authorisedToAct}
			label="I am authorised to act on behalf of the Estate"
			id="auth"
		></Checkbox>
	</FormColumn>
</FormRow>

<FormRow>
	<FormColumn>
		<Select
			label="Capacity"
			required
			{disabled}
			id="cap"
			bind:value={claimantDetails.capacityId}
			optionList={$lookups.deceasedCapacity}
			textProperty="lookupName"
			valueProperty="id"
		></Select>
	</FormColumn>
</FormRow>

<style>
	.executors {
		border-top: 1px solid var(--color-border);
	}

	.executor {
		position: relative;
	}

	.delete {
		border: none;
		outline: none;
		background-color: transparent;
		font-size: 1.1rem;
		font-weight: 700;
		color: var(--color-primary);
		margin-top: 10px;
	}
</style>
